import { DataType, MultiLineSort, SortEnum, SortType } from "../Controls/MultiControls/MultiLine/MultiLineTypes";
import { NodeViewModel } from "../Engine/Core/Store/FormViewModel";

import { parseDateString, tryGetValidDateShape } from "./DateHelpers";
import { getIn } from "./ReduxStateHelpers";

export function sortInstances(
    instances: readonly string[],
    viewModel: NodeViewModel,
    multilineSort?: MultiLineSort
): string[] {
    if (multilineSort == undefined) {
        return [...instances];
    }
    const { dataType, value: sortType } = multilineSort;
    const newInstances = [...instances];
    const [, path] = multilineSort.dataPath.split("/*/");
    if (path === undefined) {
        throw new Error("To sort instances path must be as mask");
    }
    newInstances.sort((a: string, b: string): number => {
        const aValue: string = getIn(viewModel, [a, ...path.split("/"), ".", "value"], "");
        const bValue: string = getIn(viewModel, [b, ...path.split("/"), ".", "value"], "");
        if (dataType === DataType.Date) {
            return compareDate(bValue, aValue, sortType);
        } else if (dataType === DataType.CaseInsensitiveString) {
            return compareCaseInsensitiveString(bValue, aValue, sortType);
        } else {
            return compareNumber(aValue, bValue, sortType);
        }
    });

    return newInstances;
}

function compareNumber(a: string, b: string, type: SortType): number {
    if (!a && !b) {
        return 0;
    }

    if (!a) {
        return type === SortEnum.Desc ? 1 : -1;
    }

    if (!b) {
        return type === SortEnum.Desc ? -1 : 1;
    }

    return type === SortEnum.Desc ? Number(b) - Number(a) : Number(a) - Number(b);
}

function compareDate(a: string, b: string, type: SortType): number {
    const aDate = getDate(a);
    const bDate = getDate(b);

    if (!aDate && !bDate) {
        return 0;
    }

    if (!aDate) {
        return type === SortEnum.Desc ? -1 : 1;
    }

    if (!bDate) {
        return type === SortEnum.Desc ? 1 : -1;
    }

    return type === SortEnum.Desc ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime();
}

function compareCaseInsensitiveString(left: string, right: string, type: SortType): number {
    if ((left == undefined || left === "") && (right == undefined || right === "")) {
        return 0;
    }

    if (left == undefined || left === "") {
        return type === SortEnum.Desc ? -1 : 1;
    }

    if (right == undefined || right === "") {
        return type === SortEnum.Desc ? 1 : -1;
    }

    const result = left.localeCompare(right);
    if (type === SortEnum.Asc) {
        return result * -1;
    }
    return result;
}

function getDate(dateString: string): Date | undefined {
    const dateObj = tryGetValidDateShape(parseDateString(dateString));

    if (!dateObj) {
        return undefined;
    }
    const { date, month, year } = dateObj;

    return new Date(Date.UTC(year, month, date));
}
